import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Water Right Position List with Query (for remote operations)
export const getWaterRightPositionListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WR_POSITIONS}?${stringifyParams(params)}`
	);
};

// Get Water Right Position List
export const getWaterRightPositionList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WR_POSITIONS}?${stringifyParams(queryParams)}`
	);
};

// Get Single Water Right Position
export const getWaterRightPosition = water_right_position_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WR_POSITION}${water_right_position_id}`
	);
};

// Add New Water Right Position
export const addNewWaterRightPositionApi = water_right_position => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_WR_POSITION}`,
		water_right_position
	);
};

// Update Water Right Position
export const updateWaterRightPositionApi = water_right_position => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_WR_POSITION}${water_right_position._id}`,
		water_right_position
	);
};

// Delete Water Right Position
export const deleteWaterRightPositionApi = water_right_position_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_WR_POSITION}${water_right_position_id}`
	);
};

// Check if Water Right Position Exists
export const checkWaterRightPositionExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${url.CHECK_WR_POSITION_EXISTS}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
